export const YES_CLUB = {
  CARD_NUMBER: 'spl_no_card',
  CARD_ACTIVE: 'spl_card_active',
} as const;
